import { createFileRoute } from '@tanstack/react-router';
import DocsGroupHome from '@/components/Docs/DocsGroupHome';

export const Route = createFileRoute('/about-legal/')({
  component: AboutLegalHomePage,
});

function AboutLegalHomePage() {
  return <DocsGroupHome group="about-legal" />;
}
